import type { Scope } from './model';
import { scopeQuery, validDate } from './model';

const key = (track: string) => `astra-context-v1-${track.toUpperCase()}`;
export function readAnalysisContext(track: string): URLSearchParams {
  try { return new URLSearchParams(typeof window === 'undefined' ? '' : sessionStorage.getItem(key(track)) ?? ''); } catch { return new URLSearchParams(); }
}
export function saveAnalysisContext(track: string, scope: Scope) {
  try { if (typeof window !== 'undefined' && validDate(scope.asOf)) sessionStorage.setItem(key(track), scopeQuery(scope)); } catch { /* URL remains the authoritative and shareable context. */ }
}
export function analysisNavigationQuery(params: URLSearchParams, track: string) {
  const source = params.has('cycle') ? params : readAnalysisContext(track), result = new URLSearchParams();
  for (const name of ['cycle', 'date', 'massif', 'farm']) { const value = source.get(name); if (value) result.set(name, value); }
  return result.size ? `?${result}` : '';
}
